import { Markdown } from "#components/ui/markdown/Markdown.tsx";
import { useCitedMarkdownComponents } from "#features/conversations/hooks/useCitedMarkdownComponents.tsx";
import { useMessageContent, type CitedConversation } from "#features/conversations/hooks/useMessageContent.ts";
import { useCopyTracking } from "#hooks/useCopyTracking.ts";
import type { ConversationMessageModel } from "#features/conversations/types/ConversationMessageModel.ts";

interface Props {
    message: ConversationMessageModel;
    cited: CitedConversation;
    /** The answer's pill numbers by stored citation index (useMessageCitations). */
    citationNumbers: ReadonlyMap<number, number>;
}

export const AssistantMessageContent = ({ message, cited, citationNumbers }: Props) => {
    const { formattedContent } = useMessageContent(cited, message);
    const components = useCitedMarkdownComponents(cited, message, citationNumbers);

    const contentRef = useCopyTracking({
        conversationId: cited.conversationId,
        messageId: message.id
    });

    return (
        <Markdown
            content={formattedContent}
            contentRef={contentRef}
            components={components}
        />
    );
};
